module.exports = __webpack_public_path__ + "img/selected1-min.ca10f903.png";